import React from "react";
import logo from "src/assets/logo.svg";
import { useState } from "react";
import { Link } from "gatsby";
import { FaPhoneVolume } from "react-icons/fa";
import { ImCross } from "react-icons/im";
import { GiHamburgerMenu } from "react-icons/gi";
import { MobileNavMenu } from "src/components/global/MobileNavMenu";
import { Button } from "src/components/global/Button";

export const Header = () => {
  const [navActive, toggleNav] = useState(false);

  return (
    <>
      <header
        id="nav-header"
        className="bg-black lg:bg-transparent text-white w-full relative z-50 py-8 lg:py-12 flex flex-row items-center lg:-mb-44"
      >
        <div className="container mx-6 md:mx-12 lg:mx-auto max-w-7xl nav-holder flex flex-col md:flex-row items-center justify-between">
          <Link to="/">
            <img
              src={logo}
              className="w-40 md:w-48 transition-all duration-350 hover:scale-110"
            />
          </Link>

          <nav className="hidden lg:flex flex-row w-full" id="desktop-nav">
            <ul className="flex flex-col lg:flex-row w-full justify-around mx-16">
              <li>
                <Link
                  className="uppercase text-white font-secondary transition-all duration-350 hover:text-orange"
                  to="/"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  className="uppercase text-white font-secondary transition-all duration-350 hover:text-orange"
                  to="/about-us"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  className="uppercase text-white font-secondary transition-all duration-350 hover:text-orange"
                  to="/services"
                >
                  Our Services
                </Link>
              </li>
              <li>
                <Link
                  className="uppercase text-white font-secondary transition-all duration-350 hover:text-orange"
                  to="/projects"
                >
                  Projects
                </Link>
              </li>
              <li>
                <Link
                  className="uppercase text-white font-secondary transition-all duration-350 hover:text-orange"
                  to="/contact-us"
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </nav>
          <a href="tel:0418 902 461" className="hidden lg:flex">
            <Button className="w-[180px]">
              <FaPhoneVolume className="transition-all duration-350 text-lg text-white mr-2 -rotate-45 group-hover:rotate-0" />{" "}
              Call Now
            </Button>
          </a>
          <div className="flex flex-row mt-8 lg:hidden">
            <Button>
              <FaPhoneVolume className="transition-all duration-350 text-lg text-white mr-2 -rotate-45 group-hover:rotate-0" />{" "}
              Call Now
            </Button>
            {!navActive ? (
              <Button className="ml-4" onClick={() => toggleNav(!navActive)}>
                <GiHamburgerMenu className="transition-all duration-350 text-lg text-white mr-2" />{" "}
                Open Menu
              </Button>
            ) : (
              <Button className="ml-4" onClick={() => toggleNav(!navActive)}>
                <ImCross className="transition-all duration-350 text-sm text-white mr-2" />{" "}
                Close Menu
              </Button>
            )}
          </div>
        </div>
      </header>
      {navActive ? <MobileNavMenu /> : ""}
    </>
  );
};
